import { render } from "./config.vue?vue&type=template&id=527f086d&ts=true"
import script from "./config.vue?vue&type=script&lang=ts"
export * from "./config.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Plays/config.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "527f086d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('527f086d', __exports__)) {
    api.reload('527f086d', __exports__)
  }
  
  module.hot.accept("./config.vue?vue&type=template&id=527f086d&ts=true", () => {
    api.rerender('527f086d', render)
  })

}


export default __exports__